import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import FeaturePill from "./FeaturePill";

interface HeroFeature { icon?: React.ReactElement; label: string; }
interface PageHeroProps {
  title: string;
  subtitle: string;
  features?: HeroFeature[];
  illustrationSrc?: string;
  illustrationAlt?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, features, illustrationSrc, illustrationAlt = "" }) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    alignItems="center"
    justifyContent="flex-start"
    spacing={48}
    sx={{ mb: "40px" }}
  >
    {illustrationSrc && (
      <Box
        component="img"
        src={illustrationSrc}
        alt={illustrationAlt}
        sx={{
          width: { xs: "100%", sm: 260, md: 320 },
          maxWidth: "100%",
          height: "auto",
          flexShrink: 0,
          display: "block"
        }}
      />
    )}
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontWeight: 800, lineHeight: 1.15, fontSize: { xs: "1.75rem", md: "2.375rem" } }}>{title}</Typography>
      <Typography color="text.secondary" sx={{ mt: "12px", maxWidth: 540, fontSize: { xs: "0.95rem", md: "1.0625rem" }, lineHeight: 1.6 }}>
        {subtitle}
      </Typography>
      {features && features.length > 0 && (
        <Stack direction="row" sx={{ flexWrap: "wrap", gap: "8px", mt: "20px" }}>
          {features.map((f) => <FeaturePill key={f.label} icon={f.icon} label={f.label} />)}
        </Stack>
      )}
    </Box>
  </Stack>
);

export default PageHero;
